import defaultStore from '../defaultStore'
import utils from '@/utils'
import config from '@/config'

const { store } = defaultStore(`userPool/${config.AWS_ID_GROUP_USER_POOL}/group`, utils.makeUserManagerRequestData)

export default {
  ...store,
}
